﻿/*
 * @class rlPDFFilter
 * @memberOf jQuery.fn
 */

(function ($) {
   $.fn.rlPDFFilter = function () {

      const filterCategory = ['name', 'filterone', 'filtertwo'];

      let paginationCount = document.getElementById('pdfList').getAttribute('data-pagination');

      if (paginationCount == '' ) {
         paginationCount = 10;
      }

      ///
      //Initialise List.js
      ///
      var options = {
         valueNames: [
            { attr: 'data-' + filterCategory[0], name: filterCategory[0] },
            { attr: 'data-' + filterCategory[1], name: filterCategory[1] },
            { attr: 'data-' + filterCategory[2], name: filterCategory[2] }
         ],
         page: paginationCount,
         pagination: [{
            name: 'paginationTop',
            paginationClass: 'pagination',
            innerWindow: 3,
            outerWindow: 0,
            item: "<li><a class='page' href='javascript:;'></a></li>"
         }, {
            paginationClass: 'paginationBottom',
            innerWindow: 3,
            outerWindow: 0,
            item: "<li><a class='page' href='javascript:;'></a></li>"
         }]
       };

       var pdfList = new List('pdfList', options);

       /// Sort list in ascending order
       pdfList.sort(filterCategory[0], { order: 'asc' });

       /// Variables
      const filterSelect = document.getElementsByClassName('filterSelect'),
         filterOptionClass = 'filteroption',
         clearFilters = document.getElementById('clearFilters'),
         filterOneDom = document.getElementById('filterone'),
         filterTwoDom = document.getElementById('filtertwo'),
         filterOneCon = document.getElementById('filterone_container'),
         filterTwoCon = document.getElementById('filtertwo_container'),
         filterparentContainer = document.querySelector('.filtering.container'),
         paginationTop = document.getElementById('paginationTop'),
         paginationBottom = document.getElementById('paginationBottom'),
         sortSelect = document.getElementById('sortSelect'),
         sortPosition = document.getElementById('sort_position'),
         sessionFilterOne = 'FilterOne',
         sessionFilterTwo = 'FilterTwo',
         sessionURL = 'PDFFilterURL',
         sessionPaginationNumber = 'PDFFilterPag',
         sessionSort = 'PDFFilterSort',
         clearContainer = document.getElementById('clear_container');

       ///
       /// Build <select> filter options.
       ///
       for (let i = 1; i < filterCategory.length; i++) {
          let optionsArr = [];

          for (let k = 0; k < pdfList.matchingItems.length; k++) {

             const filterCatValue = pdfList.matchingItems[k]._values[filterCategory[i]];

             if (!filterCatValue || filterCatValue != "") {
                optionsArr.push(filterCatValue);
             }
             
          }

          optionsArr = optionsArr.filter(function (e) { return e }); ;
          let uniqueOptions = [...new Set(optionsArr)].sort();

          uniqueOptions.forEach(optionKeys);

          function optionKeys(key) {
             let option = document.createElement('option');
             option.innerHTML = key;
             option.value = key;
             option.className = filterOptionClass;
             document.getElementById(filterCategory[i]).appendChild(option);
          }
       }

       /// Show filter if it has options
       if (filterOneDom.children.length > 1) {
           filterOneCon.classList.remove('hide');
       }
       if (filterTwoDom.children.length > 1) {
           filterTwoCon.classList.remove('hide');
       }
       if (filterOneDom.children.length == 1 || filterTwoDom.children.length == 1) {
           clearFilters.innerHTML = 'Clear filter';
           clearContainer.classList.remove('col-md-2');
           clearContainer.classList.add('col-md-4');
       }
       if (filterOneDom.children.length == 1 && filterTwoDom.children.length == 1) {
          filterparentContainer.classList.add('hide');
          filterparentContainer.setAttribute('aria-hidden', 'true');
          document.querySelector('.listcontainer').classList.add('extrapadding');
       }
       clearFilters.classList.remove('hide');

       ///Hide pagination if items <= paginationCount
       if (pdfList.items.length <= paginationCount) {
          paginationTop.parentElement.classList.add('permhide');
          paginationBottom.parentElement.classList.add('permhide');
          sortPosition.parentElement.classList.add('permhidepagination');
       }

       ///
       /// Filter Event
       ///
       let filteroneTerm = '',
           filtertwoTerm = '';

       filterOneDom.addEventListener('change', function () {
          filteroneTerm = this.value;
          filterresults();
          sessionStorage.setItem(sessionPaginationNumber, 1);      
       });

       filterTwoDom.addEventListener('change', function () {
          filtertwoTerm = this.value;
          filterresults();
          sessionStorage.setItem(sessionPaginationNumber, 1);
       });

       function filterresults() {
          pdfList.filter(function (item) {

             let filterString;

             if (filteroneTerm != '' && filtertwoTerm != '') {
                filterString = item.values().filterone == filterOneDom.value && item.values().filtertwo == filterTwoDom.value;
             }
             else if (filteroneTerm != '') {
                filterString = item.values().filterone == filterOneDom.value
             }
             else if (filtertwoTerm != '') {
                filterString = item.values().filtertwo == filterTwoDom.value
             }
             else if (filteroneTerm == '' && filtertwoTerm == '') {
                pdfList.filter();
             }

             //list.js filter
             if (filterString) {
                return true;
             } else {
                return false;
             }

          });
       }

       ///
       /// Clear Filters
       ///
       clearFilters.addEventListener('click', function () {

          //reset list.js
          pdfList.filter();
          pdfList.search();

          for (let i = 0; i < filterSelect.length; i++) {
             filterSelect[i].selectedIndex = 0;
             updateResultInformation();
          };

          filteroneTerm = '';
          filtertwoTerm = '';

          paginationNextPrevious();

          sessionStorage.removeItem(sessionFilterOne);
          sessionStorage.removeItem(sessionFilterTwo);
          sessionStorage.setItem(sessionPaginationNumber, 1);
          
       });

       ///
       ///Sort
       ///
       sortSelect.addEventListener('change', function () {
          pdfList.sort(filterCategory[0], { order: this.value });
          onePaginationcheck();
          sessionStorage.setItem(sessionSort, this.value);
          sessionStorage.setItem(sessionURL, window.location.href);
       });

       ///
       /// Pagination
       ///
      const nextTop = document.getElementById("nextTop"),
         prevTop = document.getElementById("prevTop"),
         nextBot = document.getElementById("nextBot"),
         prevBot = document.getElementById("prevBot");

       nextTop.addEventListener("click", nextprevClick);
       prevTop.addEventListener("click", nextprevClick);
       nextBot.addEventListener("click", nextprevClick);
       prevBot.addEventListener("click", nextprevClick);

      function nextprevClick() {
         let whichPag = 'paginationTop';
         if (this.id == 'nextBot' || this.id == 'prevBot') {
            whichPag = 'paginationBottom';
         }

         setTimeout(function () {
            const focusQuery = document.querySelector("#" + whichPag + " .active a");
            focusQuery.focus();
            sessionStorage.setItem(sessionPaginationNumber, focusQuery.dataset.i);
            sessionStorage.setItem(sessionURL, window.location.href);
         }, 150);
      }

      $(".pagination").on("click", function () {
         const id = this.id;
         setTimeout(function () {
            const activePage = $("#" + id + " li.active a");
            activePage.focus();
            sessionStorage.setItem(sessionPaginationNumber, activePage.data('i'));
            sessionStorage.setItem(sessionURL, window.location.href);
         }, 150);
      });


      ///
      ///Restore Storage Session
      ///
      function pageShown(evt) {
          if (sessionStorage.getItem(sessionURL) === window.location.href) {

            if (sessionStorage.getItem(sessionFilterOne) != null) {
               filterOneDom.value = sessionStorage.getItem(sessionFilterOne);
               filteroneTerm = sessionStorage.getItem(sessionFilterOne);
               onePaginationcheck();
            }

            if (sessionStorage.getItem(sessionFilterTwo) != null) {
               filterTwoDom.value = sessionStorage.getItem(sessionFilterTwo);
               filtertwoTerm = sessionStorage.getItem(sessionFilterTwo);
               onePaginationcheck();
            }

            filterresults();

            if (sessionStorage.getItem(sessionSort) != null) {
               sortSelect.value = sessionStorage.getItem(sessionSort);
               pdfList.sort(filterCategory[0], { order: sessionStorage.getItem(sessionSort) });
               onePaginationcheck();
            }

            if (sessionStorage.getItem(sessionPaginationNumber) != null) {
               let didyefindit = false;
               const seshPagNumber = sessionStorage.getItem(sessionPaginationNumber);

               document.querySelectorAll('#paginationTop li').forEach(list => {
               if (list.firstChild.dataset.i == sessionStorage.getItem(sessionPaginationNumber)) {
                  list.firstChild.click();
                  didyefindit = true;
               }
               });
               if (didyefindit === false) {
                  for (let i = 1; i < seshPagNumber; i++) {
                     nextTop.firstChild.click();
                  };
               }
            }
            }
            else {
                sessionStorage.removeItem(sessionURL);
                sessionStorage.removeItem(sessionFilterOne);
                sessionStorage.removeItem(sessionFilterTwo);
                sessionStorage.removeItem(sessionPaginationNumber);
                sessionStorage.removeItem(sessionSort);
            }

       }

       window.addEventListener("pageshow", pageShown, false);

       ///
       //Trigger functions
       ///
       updateResultInformation();
       paginationNextPrevious();
       onePaginationcheck();
       hideEmptyPagination();
       nextPrevAria();
       disabledPaginationAria();

       pdfList.on('updated', function (pdfList) {
          updateResultInformation();
          paginationNextPrevious();
          onePaginationcheck();
          hideEmptyPagination();
          disabledPaginationAria();
       });

       pdfList.on('filterComplete', function (pdfList) {
          updateResultInformation();
          paginationNextPrevious();
          onePaginationcheck();
          hideEmptyPagination();
          setFilterStorage();
       });

       $(window).on('resize-end', function () {
          nextPrevAria();
       });


      ///
      //Functions
      ///
      
      function setFilterStorage() {
         const filterOneVal = filterOneDom.value,
            filterTwoVal = filterTwoDom.value;

         if (filterOneVal == '') {
            sessionStorage.removeItem(sessionFilterOne);
         } else {
            sessionStorage.setItem(sessionFilterOne, filterOneVal);
            sessionStorage.setItem(sessionURL, window.location.href);
         }

         if (filterTwoVal == '') {
            sessionStorage.removeItem(sessionFilterTwo);
         } else {
            sessionStorage.setItem(sessionFilterTwo, filterTwoVal);
            sessionStorage.setItem(sessionURL, window.location.href);
         }
      }

       function updateResultInformation() {

          const filterpageResults = document.getElementById('filterpage-results'),
             filterpageCurrent = document.getElementById('filterpage-current'),
             filterpageTotal = document.getElementById('filterpage-total'),
             matchingResults = pdfList.matchingItems.length,
             resultsperPage = pdfList.page,
             activePagination = document.getElementById('paginationTop').children.length > 0 ? true : false;

          let linksPlural = 'links found &ndash;',
             totalPages = Math.ceil(matchingResults / resultsperPage),
             activePage = '1';

          if (matchingResults == 1) {
             linksPlural = 'link found &ndash;';
          }

          if (activePagination) {
             activePage = document.getElementById('paginationTop').querySelector('.active').querySelector('.page').getAttribute('data-i');
          }

          if (activePage > totalPages) {
             activePage = totalPages;
          }

          if (matchingResults == 0) {
             activePage = 1;
             totalPages = 1;
          }

          filterpageResults.innerHTML = matchingResults + ' ' + linksPlural;
          filterpageCurrent.innerHTML = 'page ' + activePage;
          filterpageTotal.innerHTML = ' of ' + totalPages;

       }

      function paginationNextPrevious() {

         const paginationTop = document.getElementById('paginationTop'),
            paginationPrevious = document.querySelectorAll('.previous'),
            paginationNext = document.querySelectorAll('.next'),
            pagActive = paginationTop.querySelector('.active'),
            matchingResults = pdfList.matchingItems.length;

         if (paginationTop.children.length != 0) {

            let pagNext = pagActive.nextSibling,
               pagPrevious = pagActive.previousSibling;

            if (pagNext != null) {
               pagNext = pagNext.querySelector('.page').getAttribute('data-i');
            }

            if (pagPrevious != null) {
               pagPrevious = pagPrevious.querySelector('.page').getAttribute('data-i');
            }

            paginationPrevious.forEach(Previous => {
               Previous.firstChild.setAttribute('data-i', pagPrevious);
               Previous.firstChild.setAttribute('data-page', paginationCount);
               if (Previous.firstChild.getAttribute('data-i') != 'null') {
                  Previous.classList.remove('hide');
               } else {
                  Previous.classList.add('hide');
               }
               if (matchingResults == 0) {
                  Previous.classList.add('hide');
               }
            });

            paginationNext.forEach(Next => {
               Next.firstChild.setAttribute('data-i', pagNext);
               Next.firstChild.setAttribute('data-page', paginationCount);
               if (Next.firstChild.getAttribute('data-i') != 'null') {
                  Next.classList.remove('hide');
               } else {
                  Next.classList.add('hide');
               }
               if (matchingResults == 0) {
                  Next.classList.add('hide');
               }
            });

         }
      }

      function onePaginationcheck() {
         setTimeout(function () {
            if (paginationTop.children.length != 0) {
               /// hide pagination active if only 1 page

               if (paginationTop.children.length == 1) {
                  paginationBottom.firstChild.setAttribute('aria-hidden', 'true');
                  paginationBottom.firstChild.classList.add('hide');
                  sortPosition.classList.add('nopagination');
                  paginationTop.firstChild.setAttribute('aria-hidden', 'true');
                  paginationTop.firstChild.classList.add('hide');

               }
               else {
                  paginationTop.firstChild.removeAttribute('aria-hidden');
                  paginationBottom.firstChild.removeAttribute('aria-hidden');
                  paginationTop.firstChild.classList.remove('hide');
                  paginationBottom.firstChild.classList.remove('hide');
                  sortPosition.classList.remove('nopagination');
               }
            }
         }, 10);
      }

      function hideEmptyPagination() {

         if (paginationBottom.children.length <= 1) {
            paginationBottom.parentElement.classList.add('hide');
         } else {
            paginationBottom.parentElement.classList.remove('hide');
         }

         if (pdfList.matchingItems.length <= 1) {
            sortPosition.classList.add('hide');
            paginationTop.parentElement.classList.add('hide');
         }
         else {
            sortPosition.classList.remove('hide');
            paginationTop.parentElement.classList.remove('hide');
         }
      }

      function nextPrevAria() {
         const header = document.querySelector('header'),
            smLogo = document.querySelector('header .logo-sm'),
            next = 'next',
            previous = 'previous';

         if (typeof (header) != 'undefined' && header != null && header.getAttribute('id') == 'campaign-header') {
            if (window.innerWidth <= 992) {
               addAria();
            } else {
               removeAria();
            }
         }
         else if (typeof (header) != 'undefined' && header != null) {
            if (window.getComputedStyle(smLogo).display != "none") {
               addAria();
            } else {
               removeAria();
            }
         }

         function addAria() {
            nextTop.firstChild.setAttribute('aria-label', next);
            prevTop.firstChild.setAttribute('aria-label', previous);
         }
         function removeAria() {
            nextTop.firstChild.removeAttribute('aria-label');
            prevTop.firstChild.removeAttribute('aria-label');
         }
      }

      function disabledPaginationAria() {
         setTimeout(function () {
            const disabledTop = document.querySelector('#paginationTop li.disabled'),
               disabledBot = document.querySelector('#paginationBottom li.disabled');

            if (disabledTop != null) {
               disabledTop.setAttribute('aria-hidden', 'true');
               disabledTop.firstChild.setAttribute('tabindex', '-1');
            }

            if (disabledBot != null) {
               disabledBot.setAttribute('aria-hidden', 'true');
               disabledBot.firstChild.setAttribute('tabindex', '-1');
            }
         }, 150);
      }

   }
}(jQuery));